import client from "./client";
import axios from "axios";
const base = "/accounting";
const pub = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/accounting` });
export const publicSignInfo = async (params) => (await pub.get("/public/sign-info", { params })).data;
export const publicSign = async (payload) => (await pub.post("/public/sign", payload)).data;
export const publicSignReject = async (payload) => (await pub.post("/public/sign-reject", payload)).data;

export const listAccounts = async () => (await client.get(`${base}/accounts`)).data;
export const accountTree = async () => (await client.get(`${base}/accounts/tree`)).data;
export const createAccount = async (body) => (await client.post(`${base}/accounts`, body)).data;
export const updateAccount = async (code, body) => (await client.patch(`${base}/accounts/${code}`, body)).data;

export const listPeriods = async () => (await client.get(`${base}/periods`)).data;
export const createPeriod = async (code) => (await client.post(`${base}/periods`, { code })).data;
export const setPeriodStatus = async (code, status) => (await client.patch(`${base}/periods/${code}`, { status })).data;

export const listEntries = async (params) => (await client.get(`${base}/journal`, { params })).data;
export const entryDetail = async (id) => (await client.get(`${base}/journal/${id}`)).data;
export const postEntry = async (body) => (await client.post(`${base}/journal`, body)).data;
export const reverseEntry = async (id, note) => (await client.post(`${base}/journal/${id}/reverse`, { note })).data;

export const trialBalance = async (params) => (await client.get(`${base}/reports/trial-balance`, { params })).data;
export const incomeStatement = async (params) => (await client.get(`${base}/reports/income-statement`, { params })).data;
export const balanceSheet = async (params) => (await client.get(`${base}/reports/balance-sheet`, { params })).data;
export const cashFlow = async (params) => (await client.get(`${base}/reports/cash-flow`, { params })).data;
export const agingReport = async (params) => (await client.get(`${base}/reports/aging`, { params })).data;
export const segmentReport = async (params) => (await client.get(`${base}/reports/segments`, { params })).data;
export const equityChanges = async (params) => (await client.get(`${base}/reports/equity-changes`, { params })).data;
export const eclMatrix = async () => (await client.get(`${base}/reports/ecl-matrix`)).data;
export const saveEclMatrix = async (body) => (await client.put(`${base}/reports/ecl-matrix`, body)).data;

export const listBoxes = async () => (await client.get(`${base}/cash/boxes`)).data;
export const createBox = async (body) => (await client.post(`${base}/cash/boxes`, body)).data;
export const updateBox = async (id, body) => (await client.patch(`${base}/cash/boxes/${id}`, body)).data;
export const listMoves = async (params) => (await client.get(`${base}/cash/moves`, { params })).data;
export const listRecons = async (params) => (await client.get(`${base}/cash/reconciliations`, { params })).data;
export const closeDay = async (body) => (await client.post(`${base}/cash/reconciliations`, body)).data;

export const listContacts = async (params) => (await client.get(`${base}/contacts`, { params })).data;
export const createContact = async (body) => (await client.post(`${base}/contacts`, body)).data;
export const openDocuments = async (id) => (await client.get(`${base}/contacts/${id}/open-documents`)).data;
export const statement = async (id, params) => (await client.get(`${base}/contacts/${id}/statement`, { params })).data;

export const listBills = async (params) => (await client.get(`${base}/bills`, { params })).data;
export const createBill = async (body) => (await client.post(`${base}/bills`, body)).data;
export const ocrBill = async (file) => {
  const data = new FormData();
  data.append("file", file);
  return (await client.post(`${base}/bills/ocr`, data, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const approveBill = async (id, note) =>
  (await client.post(`${base}/bills/${id}/approve`, null, { params: { note } })).data;
export const payBill = async (id, method, cashbox_id, receiver_name, receiver_phone, receiver_user_id) =>
  (await client.post(`${base}/bills/${id}/pay`, null,
    { params: { method, cashbox_id, receiver_name, receiver_phone, receiver_user_id } })).data;
export const listInboxBills = async () => (await client.get(`/inbox/bills`)).data;
export const getInboxBill = async (id) => (await client.get(`/inbox/bills/${id}`)).data;
export const signInboxBill = async (id, signature_dataurl) =>
  (await client.post(`/inbox/bills/${id}/sign`, { signature_dataurl })).data;
export const rejectInboxBill = async (id, reason) =>
  (await client.post(`/inbox/bills/${id}/reject`, { reason })).data;

export const createBillSignLink = async (id, lang) =>
  (await client.post(`${base}/bills/${id}/sign-link`, null, { params: { lang } })).data;
export const rejectBill = async (id, reason) =>
  (await client.post(`${base}/bills/${id}/reject`, null, { params: { reason } })).data;
export const listInvoices = async (params) => (await client.get(`${base}/invoices`, { params })).data;
export const createInvoice = async (body) => (await client.post(`${base}/invoices`, body)).data;
export const issueInvoice = async (id) => (await client.post(`${base}/invoices/${id}/issue`)).data;
export const listPayments = async (params) => (await client.get(`${base}/payments`, { params })).data;
export const createPayment = async (body) => (await client.post(`${base}/payments`, body)).data;
export const listTransfers = async (params) => (await client.get(`${base}/transfers`, { params })).data;
export const previewTransfer = async (params) => (await client.get(`${base}/transfers/preview`, { params })).data;
export const requestTransfer = async (body) => (await client.post(`${base}/transfers`, body)).data;
export const approveTransfer = async (id) => (await client.post(`${base}/transfers/${id}/approve`)).data;
export const acctAudit = async () => (await client.get(`${base}/audit`)).data;
export const myAcctPerms = async () => (await client.get(`${base}/perms/me`)).data;
export const acctDashboard = async (params) => (await client.get(`${base}/dashboard`, { params })).data;
export const acctExecutive = async (params) => (await client.get(`${base}/executive`, { params })).data;
export const acctAlerts = async () => (await client.get(`${base}/alerts`)).data;
export const listProjects = async () => (await client.get(`${base}/projects`)).data;
export const createProject = async (body) => (await client.post(`${base}/projects`, body)).data;
export const projectDetail = async (id) => (await client.get(`${base}/projects/${id}`)).data;
export const listStaffPayments = async (params) => (await client.get(`${base}/staff-payments`, { params })).data;
export const createStaffPayment = async (body) => (await client.post(`${base}/staff-payments`, body)).data;
export const listAssets = async (params) => (await client.get(`${base}/assets`, { params })).data;
export const createAsset = async (body) => (await client.post(`${base}/assets`, body)).data;
export const runDepreciation = async (month) => (await client.post(`${base}/assets/depreciation`, { month })).data;
export const disposeAsset = async (id, proceeds) => (await client.post(`${base}/assets/${id}/dispose`, { proceeds })).data;
export const acctSettings = async () => (await client.get(`${base}/settings`)).data;
export const saveAcctSettings = async (body) => (await client.put(`${base}/settings`, body)).data;
export const uploadReceipt = async (file) => {
  const data = new FormData();
  data.append("file", file);
  return (await client.post(`${base}/receipts`, data, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const listAcctPerms = async () => (await client.get(`${base}/perms`)).data;
export const setAcctPerms = async (userId, acct_perms) =>
  (await client.patch(`${base}/perms/${userId}`, { acct_perms })).data;
